<template>
  <div id="contenedor-eliminar-actividad">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Actividad </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar esta actividad? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarActividad"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixActividades from './mixActividades';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarActividad',
  mixins: [mixActividades],
  props: {
    actividadEliminar: {
      type: Object,
      required: true,
    },
    idReferenciaActividad: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      idReferencia: this.idReferenciaActividad,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
